import { showAlertToast } from './showAlertToast'

export type ToastType = 'loading' | 'error' | 'success' | 'warning'

export default (type: ToastType, message: string) => {
  showAlertToast[type](message)
}
